"use server";

import { redirect } from "next/navigation";
import { cookies } from "next/headers";
import bcrypt from "bcryptjs";
import { getDb } from "@/lib/mongodb/client";
import { signToken } from "@/lib/auth/jwt";

export async function login(formData: FormData) {
  const email = formData.get("email") as string;
  const password = formData.get("password") as string;

  if (!email || !password) {
    return { error: "Email and password are required" };
  }

  const db = await getDb();
  const user = await db.collection("users").findOne({ email: email.toLowerCase().trim() });

  if (!user || !user.password_hash) {
    return { error: "Invalid email or password" };
  }

  const passwordMatch = await bcrypt.compare(password, user.password_hash);
  if (!passwordMatch) {
    return { error: "Invalid email or password" };
  }

  const token = signToken({ id: user.id, email: user.email });

  const cookieStore = await cookies();
  cookieStore.set("session", token, {
    httpOnly: true,
    secure: process.env.NODE_ENV === "production",
    maxAge: 60 * 60 * 24 * 7, // 7 days
    sameSite: "lax",
    path: "/",
  });

  // Non-httpOnly copy so the client can read the JWT for Hocuspocus WebSocket auth.
  // This is intentional: the JWT is validated server-side on every use.
  cookieStore.set("_token", token, {
    httpOnly: false,
    secure: process.env.NODE_ENV === "production",
    maxAge: 60 * 60 * 24 * 7, // 7 days
    sameSite: "lax",
    path: "/",
  });

  cookieStore.set("user", JSON.stringify({ id: user.id, email: user.email }), {
    httpOnly: false, // Client-side readable
    secure: process.env.NODE_ENV === "production",
    maxAge: 60 * 60 * 24 * 7, // 7 days
    sameSite: "lax",
    path: "/",
  });

  redirect("/app");
}
